export var flexContent={display:"flex",flexWrap:"wrap"};export var flexContentCenter={display:"flex",alignItems:"center",justifyContent:"center"};